import { CSSObject } from '@emotion/react';
import { useTheme } from '@cvent/carina/components/ThemeProvider';

export const usePageStyle = (): Record<string, CSSObject> => {
  const { backgroundColor } = useTheme();

  return {
    background: {
      backgroundColor: backgroundColor.surface
    },
    colFlex: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    }
  };
};
